import React, { FunctionComponent, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

// import { loginAtom, renew_sign_in } from '../../lib/auth';

import AddIcon from '@mui/icons-material/Add';

import {
  Fab as Fb
} from '@mui/material';

// const { DateTime } = require("luxon");

type Props = {
  onClick: () => void;
  icon?: ReactElement;
  sx?: any;
};

export const Fab: FunctionComponent<Props> = ({onClick, icon, sx}) => {
  const {t, i18n} = useTranslation(['translations']);

  return (<Fb
    aria-label={t("coach.general.actions.new")}
    sx={{
      position: 'absolute',
      bottom: 16,
      right: 16,
      zIndex: 1205,
      ...sx
    }}
    color="primary"
    onClick={() => {
      onClick();
    }}
  >
    {!icon && <AddIcon />}
    {!!icon && icon}
  </Fb>);
}
